/**
 * Truncates a string if it exceeds the specified maximum length.
 * @param str - The string to truncate.
 * @param maxLength - The maximum length of the truncated string.
 * @returns The truncated string.
 */
export function truncate(str = '', maxLength: number): string {
  str = str.trim()

  if (str.length <= maxLength) {
    return str
  }

  return str.slice(0, maxLength).trim() + '…'
}

// Examples
// console.log(`Original string: ${truncate('short and pithy', 17)}`) // Outputs 'short and pithy'
// console.log(`Truncated string: ${truncate('way too much copy to fit into the approved design', 17)}`) // Outputs 'way too much copy...'


export function truncateInSericeNames(query: string | undefined, titles: string[] | undefined): string | undefined {
  if (titles && titles.length == 1) {
    return titles[0]
  } else if ((!query || query.length == 0) && titles && titles.length > 1) {
    if (titles.length > 2) {
      return `${titles[0]} +${titles.length - 1} more`
    }
    else {
      return `${titles[0]} +${titles.length - 1} more`
    }
  } else if (query && query.length > 0 && titles && titles.length > 1) {
    const title = titles.reduce((acc, y) => {
      if (y.toLowerCase().indexOf(query) >= 0) {
        return y
      }
      else {
        return acc
      }
    }, titles[0])
    if (titles.length > 2) {
      return `${title} +${titles.length - 1} more`
    }
    else {
      return `${title} +${titles.length - 1} more`
    }
  }
  return undefined
}

export function truncateInSericeName(query: string | undefined, inServiceName: string | undefined): string {
  console.log(query, inServiceName)
  const regexp = /In-service title: (.*?)\)/
  const matches = inServiceName?.match(regexp)
  const names = matches?.[1]?.split(",").map(x => x.trim())
  if (names) {
    const index = inServiceName?.indexOf(" (In-service")
    return `<span style="color: black;">${inServiceName?.substring(0, index)} <span><i style="color: #595959; font-size: 15px;">(in-service title: ${truncateInSericeNames(query, names)})</i>`
  }
  else {
    return inServiceName ? `<span style="color: black;">${inServiceName}<span>` : ''
  }
}
